import UserService from '@/services/UserService';
import NetworkService from '@/services/NetworkService';
export default {
  name: 'About',
  data() {
    return {
      networkInfo: null,
      content: null,
      image: '/img/stock/about-us-default.png'
    };
  },
  async mounted() {
    await this.getNetworkInfo();
    await this.getAboutpageContent();
  },
  methods: {
    async getNetworkInfo() {
      this.networkInfo = await UserService.getNetworkInfo();
    },
    async getAboutpageContent() {
      const response = await NetworkService.getAboutpageContent();
      this.content = response.data.content;
      if (response.data.image) {
        this.image = response.data.image;
      }
    }
  }
};